const ddados = {
  Titulo: "Responder Exigência",
  Campos: {
    Analise: {
      Tipo: 'number',
      Label: 'Análise',
      Placeholder: 'Análise',
      Desabilitado: true,
    },
    TipoDocumento: {
      Tipo: 'text',
      Label: 'Documento',
      Placeholder: 'Documento',
      Desabilitado: true,
    },
    Exigencia: {
      Tipo: 'text',
      Label: 'Exigência',
      Placeholder: 'Exigência',
      Desabilitado: true,
    },
    Motivo: {
      Tipo: 'textarea',
      Label: 'Motivo',
      Placeholder: 'Motivo',
      Tamanho: 1000,
      Linhas: 6,
      Desabilitado: true,
    },
    ExigenciaDocumento: {
      Tipo: 'combobox',
      Label: 'É Documento',
      Placeholder: 'É Documento',
      Desabilitado: true,
      itens: [
        { Texto: 'Sim', Valor: 1 },
        { Texto: 'Não', Valor: 0 },
      ],
    },
    Resposta: {
      Tipo: 'textarea',
      Label: 'Resposta',
      Placeholder: 'Resposta',
      Tamanho: 1000,
      Linhas: 6,
      Obrigatorio: true,
    },
    DescricaoArquivo: {
      Tipo: 'textarea',
      Label: 'Descrição',
      Placeholder: 'Descrição',
      Tamanho: 400,
      Linhas: 6,
      Obrigatorio: true,
    },
    Arquivo: {
      Tipo: 'file',
      Label: 'Arquivo',
      Tooltip: 'Arquivo (Permitido apenas arquivos no formato PDF)',
      TipoFileUpload: 'file',
      extensionsAllowed: 'pdf',
      Obrigatorio: true,
    },
  }
};

export { ddados };
